import React from "react";
import {Modal} from 'react-bootstrap';

const CustomModal = (props) => {


  return (
    <div className="main-wrapper">
      <Modal
        {...props}
        dialogClassName="modal-120w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        backdrop="static"
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            No Activity Detected
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            We don't see any activity from last few minutes/hours. You'll be logout within a minutes.
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CustomModal;
